import styles from '../../assets/styles/Receipt/Receipt.module.scss';
import { MimaButton, MimaText } from '../../components';
import { EditReceiptContainer } from '../../containers';
import { MdModeEditOutline } from 'react-icons/md';
import React from 'react';

const ReceiptSummary = ({ editReceipt, goToEditReceipt }) => {
	return (
		<div>
			{!editReceipt && (
				<div className={styles.summary}>
					<div className={styles.summary__edit} onClick={goToEditReceipt}>
						<MdModeEditOutline /> Edit
					</div>
					<MimaText align="center" variant="subtitle">
						Receipt Preview
					</MimaText>
					<MimaText
						align="center"
						variant="subtitleBold"
						mt={2}
						color="var(--color-primary)">
						Hicks Enterprises
					</MimaText>
					<MimaText align="center" variant="small" mb={2}>
						Receipt: #128732
					</MimaText>

					<div className={styles.summary__beside}>
						<MimaText variant="bodyBold" color="var(--color-primary)">
							BILLING INFO
						</MimaText>
						<MimaText variant="small">
							Receipt: <span className={styles.summary__details}>#128732</span>
						</MimaText>
					</div>

					<MimaText mt={2}>
						Name: Funmi Lawal <br />
						Phone: 09098088767 <br />
						Email: janedoe2@gmail.com
					</MimaText>
					<div className={styles.summary__line}></div>
					<MimaText variant="bodyBold" color="var(--color-primary)">
						ORDER SUMMARY
					</MimaText>
					<MimaText mt={2} mb={2}>
						<span className={styles.summary__details}>Service:</span> Hermes Bag
						<br />
						<span className={styles.summary__details}>Quantity:</span> 1 <br />
						<span className={styles.summary__details}>Discount:</span>
						1,000,000.00 <br />
						<span className={styles.summary__details}>Total amount:</span>
						15,000,000.00 <br />
						<span className={styles.summary__details}>Amount paid:</span>
						10,000,000.00 <br />
						<span className={styles.summary__details}>Payment type:</span>
						Transfer <br />
						<span className={styles.summary__details}>Payment Value:</span> Full
						Payment <br />
						<span className={styles.summary__details}>To balance:</span>
						5,125,000.00
						<br />
						<span className={styles.summary__details}>Note:</span> It should be
						the Birkin Tote bag
					</MimaText>
					<div className={styles.summary__button}>
						<MimaButton
							title="Download"
							variant="small"
							buttonColor="var(--color-dark-3)"
							width={20}
						/>
						<MimaButton title="Send" variant="small" width={20} />
					</div>
				</div>
			)}

			{editReceipt && <EditReceiptContainer />}
		</div>
	);
};

export default ReceiptSummary;
